import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { menuItems, menuTabs } from "../data/menu";
import type { MenuCategory } from "../types/cafe";
import { formatShortIDR } from "../utils/currency";
export function MenuSection() {
  const [tab, setTab] = useState<MenuCategory>("drinks");
  const current = menuTabs.find(t => t.id === tab) ?? menuTabs[0];
  const items = menuItems.filter(item => item.category === tab);
  return <section id="menu" className="bg-cream-dark py-20 lg:py-28" data-id="element-197" data-mp="137fawm4i0t1c">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 sm:px-8 lg:grid-cols-[320px_1fr] lg:gap-20" data-id="element-198" data-mp="yc9svye7vyij">
        <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-199" data-mp="1c3obi447pxp2">
          <h2 className="text-3xl font-semibold tracking-tight text-ink sm:text-4xl" data-id="element-200" data-mp="17avbftjovdjb">Menu andalan</h2>
          <p className="mt-4 text-base leading-relaxed text-ink-muted" data-id="element-201" data-mp="jl0x17jq1gwy">
            Harga dalam Rupiah (ribuan). Pesan di kasir atau minta kami siapkan sebelum kamu
            datang.
          </p>

          <div role="tablist" aria-label="Kategori menu" className="mt-8 flex flex-col gap-1" data-id="element-202" data-mp="3qn1gyquzm4cq">
            {menuTabs.map(t => {
            const active = t.id === tab;
            return <button key={t.id} role="tab" aria-selected={active} aria-controls="menu-panel" onClick={() => setTab(t.id)} className={`flex items-center justify-between rounded-card px-4 py-3 text-left text-[15px] font-medium transition-colors duration-150 ${active ? "bg-espresso text-cream" : "text-ink hover:bg-cream"}`} data-id="element-203" data-mp="46f3lkmvtlpe">
                  {t.label}
                  <span className={`text-xs ${active ? "text-cream/60" : "text-ink-muted"}`} data-id="element-204" data-mp="3mlfvih4e0hqx">
                    {menuItems.filter(i => i.category === t.id).length}
                  </span>
                </button>;
          })}
          </div>
        </div>

        <div id="menu-panel" role="tabpanel" aria-label={current.label} data-id="element-205" data-mp="2xwslzasri38t">
          <AnimatePresence mode="wait" data-id="element-206" data-mp="2syh7unvfp6ks">
            <motion.div key={tab} initial={{
            opacity: 0,
            y: 6
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -6
          }} transition={{
            duration: 0.18,
            ease: [0.23, 1, 0.32, 1]
          }} data-id="element-207" data-mp="2sxpe7iledix5">
              <p className="border-b border-cream-line pb-5 text-lg text-ink" data-id="element-208" data-mp="2f6ub6mxkxw1h">{current.blurb}</p>
              <ul className="grid gap-x-12 md:grid-cols-2" data-id="element-209" data-mp="2a89cwt1w1mfo">
                {items.map(item => <li key={item.id} className="border-b border-cream-line py-6" data-id="element-210" data-mp="2nzxngrwho2uj">
                    <div className="flex items-baseline gap-3" data-id="element-211" data-mp="2j8pd9tnc4dgb">
                      <h3 className="text-base font-semibold text-ink" data-id="element-212" data-mp="2j74fzw9myger">{item.name}</h3>
                      <span className="flex-1 translate-y-[-3px] border-b border-dotted border-ink-muted/40" aria-hidden="true" data-id="element-213" data-mp="1vhsab6dioqh7" />
                      <span className="text-base font-semibold text-sage" data-id="element-214" data-mp="1hct5qrtfyjff">
                        {formatShortIDR(item.price)}
                      </span>
                    </div>
                    <p className="mt-2 text-sm leading-relaxed text-ink-muted" data-id="element-215" data-mp="17ggavqm5tzj3">{item.description}</p>
                    {item.tag && <span className="mt-3 inline-block rounded-full bg-sage-soft px-2.5 py-0.5 text-xs font-medium text-sage-dark" data-id="element-216" data-mp="1ccdr7wxfb5vv">
                        {item.tag}
                      </span>}
                  </li>)}
              </ul>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </section>;
}